import React from 'react'
import { useDeviceReadings } from '../hooks/useDeviceReadings'
import { useAuthContext } from '../contexts/AuthContext'

interface Props {
  sigfoxId: string
  from: number
  to: number
}

export function TestReadingsCache({ sigfoxId, from, to }: Props) {
  const { email } = useAuthContext()

  // Use the caching hook
  const { data, isLoading, error } = useDeviceReadings(
    sigfoxId,
    from,
    to,
    1000
  )

  if (isLoading) {
    return <div>Loading readings...</div>
  }

  if (error) {
    return <div>Error: {error.message}</div>
  }

  if (!data) {
    return <div>No data</div>
  }

  const sensorCount = Object.keys(data.sensors || {}).length
  const totalReadings = data.readings?.length || 0

  // Get sensor list for compact display
  const sensorList = Object.entries(data.sensors || {})
    .map(([key, sensor]) => {
      const readingsCount = sensor.data?.length || 0
      return readingsCount > 0 ? `${key}: ${sensor.sensorName || 'Unknown'} (${readingsCount})` : null
    })
    .filter(Boolean)

  const firstReading = data.readings?.[0]?.timestamp
  const lastReading = data.readings?.[data.readings.length - 1]?.timestamp

  return (
    <div style={{
      padding: '8px 12px',
      border: '1px solid #e5e7eb',
      borderRadius: '4px',
      backgroundColor: '#f9fafb',
      fontSize: '12px',
      lineHeight: '1.5',
      color: '#6b7280',
      marginTop: '16px'
    }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', alignItems: 'center' }}>
        <span><strong>Cache Test:</strong> {email?.split('@')[0]}</span>
        <span>Device: <strong>{sigfoxId}</strong></span>
        <span>Range: {new Date(from * 1000).toLocaleDateString()} - {new Date(to * 1000).toLocaleDateString()}</span>
        <span>Sensors: <strong>{sensorCount}</strong></span>
        <span>Readings: <strong>{totalReadings}</strong></span>
        <span>Source: <strong style={{ color: data.cacheSource === 'cache' ? '#10b981' : data.cacheSource === 'api' ? '#ef4444' : '#f59e0b' }}>{data.cacheSource}</strong></span>
        <span>Hit Ratio: <strong>{((data.cacheHitRatio || 0) * 100).toFixed(1)}%</strong></span>
        {data.latencyMs !== undefined && (
          <span>Latency: <strong>{data.latencyMs}ms</strong></span>
        )}
        {firstReading && lastReading && (
          <span style={{ fontSize: '11px' }}>
            {new Date(firstReading * 1000).toLocaleString()} - {new Date(lastReading * 1000).toLocaleString()}
          </span>
        )}
      </div>
      {sensorList.length > 0 && (
        <div style={{ marginTop: '4px', fontSize: '11px' }}>
          {sensorList.join(' • ')}
        </div>
      )}
    </div>
  )
}
